// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1v7_X","colMin":"styles_colMin__zUcJy","colCheckbox":"styles_colCheckbox__AiucL"};